import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/workflows/building-blocks/preview-pdf/dynamic-html-templates/{id}']['POST'];

type Props = ThisApi['params'] & { jsonData: ThisApi['body'] };

const previewDynamicHtmlTemplatesPdf = async ({ id, jsonData }: Props): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.post(`/workflows/building-blocks/preview-pdf/dynamic-html-templates/${id}`, jsonData);
  return response.data;
};

export default previewDynamicHtmlTemplatesPdf;